import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import LanguageTabs from '../../Tabs/LanguageTabs';
import LanguageTab from '../../Tabs/LanguageTab';
import FormInput from '../../Form/FormInput';
import FormTextarea from '../../Form/FormTextarea';

const languages = ['EN', 'ES', 'CA', 'PT'];

class EventLanguageTabsContainer extends Component {
  state = {};

  componentDidMount() {
    const { sendTabsInfo, getTabsInfo } = this.props;

    languages.map(lang => this.setState({ [`eventReadableName${lang}`]: (sendTabsInfo && sendTabsInfo.hasOwnProperty('eventReadableName') && sendTabsInfo.eventReadableName !== null && sendTabsInfo.eventReadableName[lang.toLowerCase()]) || '' }));
    languages.map(lang => this.setState({ [`image${lang}`]: (sendTabsInfo && sendTabsInfo.hasOwnProperty('image') && sendTabsInfo.image !== null && sendTabsInfo.image[lang.toLowerCase()]) || '' }));
    languages.map(lang => this.setState({ [`description${lang}`]: (sendTabsInfo && sendTabsInfo.hasOwnProperty('description') && sendTabsInfo.description !== null && sendTabsInfo.description[lang.toLowerCase()]) || '' }, () => getTabsInfo(this.state)));
  }

  storeText = (lang, value) => {
    const { getTabsInfo } = this.props;
    this.setState(
      {
        [lang]: value,
      },
      () => {
        getTabsInfo(this.state);
      },
    );
  };

  render() {
    const { action } = this.props;
    return (
      <div className="bg-black text-white mt-4 language-tabs ">
        <LanguageTabs>
          {languages.map(lang => (
            <LanguageTab label={lang} key={lang}>
              <div className="bg-greyWithinForm pt-1 pb-px px-8 rounded">
                <FormInput name={`eventReadableName${lang}`} title="Event Readable Name" value={(this.state[`eventReadableName${lang}`] && this.state[`eventReadableName${lang}`]) || ''} storeText={this.storeText} action={action} />
                <FormInput name={`image${lang}`} title="Image" value={(this.state[`image${lang}`] && this.state[`image${lang}`]) || ''} storeText={this.storeText} action={action} />
                {/* required={lang === 'EN' ? true : !this.state.eventReadableNameEN} */}
                <FormTextarea name={`description${lang}`} title="Description" value={(this.state[`description${lang}`] && this.state[`description${lang}`]) || ''} storeText={this.storeText} action={action} />
              </div>
            </LanguageTab>
          ))}
        </LanguageTabs>
      </div>
    );
  }
}

EventLanguageTabsContainer.propTypes = {
  getTabsInfo: PropTypes.func.isRequired,
  sendTabsInfo: PropTypes.shape(),
  action: PropTypes.string.isRequired,
};

EventLanguageTabsContainer.defaultProps = {
  sendTabsInfo: {},
};

export default EventLanguageTabsContainer;
